var React = require('react');

function XInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.625 6.1875L6.625 18.1875","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.625 6.1875L18.625 18.1875","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

XInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = XInline;

XInline.default = XInline;
